<template>
    <div>
        <div>
            <div>
                <h2  v-html="$t('intern_inserieren.bezahlung_pruefen')"></h2>
                <div v-html="$t('intern_inserieren.veroeffentlichen')"></div>
            </div>
            <!--<h2 v-html="$t('intern_inserieren.zahlung_lastschrift')" class="mb-3"></h2>-->
            <table class="checkout my-4" >
                <thead>
                    <tr>
                        <th class="text-left">{{$t('intern_inserieren.item_beschreibung')}}</th>
                        <th class="text-right">{{$t('intern_inserieren.item_preis')}}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-if="selectedPacket">
                        <td class="pointer text-left" @click="$emit('moveTo','packet_choice')">
                            {{selectedPacket.name}}
                        </td>
                        <td class="text-right">{{selectedPacket.price * selectedPacket.duration | netto | currency}}</td>
                    </tr>
                    <template v-if="extensions">
                        <tr v-for="ext in extensions">
                            <td class="pointer text-left" @click="$emit('moveTo','improvement')">
                                {{ext.title}}
                            </td>
                            <td class="text-right">{{ext.price | netto | currency}}</td>
                        </tr>
                    </template>
                </tbody>
                <tfoot>
                    <tr>
                        <td class="text-left">{{$t('intern_inserieren_objekt_upgrade_regular.gesamt_netto')}}</td>
                        <td class="text-right">{{total_net | currency}}</td>
                    </tr>
                    <tr>
                        <td class="text-left">{{$t('intern_inserieren_objekt_upgrade_regular.mwst')}}</td>
                        <td class="text-right">{{mwst | currency}}</td>
                    </tr>
                    <tr>
                        <td class="text-left">{{$t('intern_inserieren_objekt_upgrade_regular.gesamt')}}</td>
                        <td class="text-right brutto">{{total_gross | currency}}</td>
                    </tr>
                </tfoot>
            </table>
            <hr>
            <div v-if="sepaInfo">
              <div class="mb-4" v-html="$t('intern_warenkorb_bezahlen.bankdaten_erforderlich')"></div>

              <div v-if="err != null" class="alert alert-danger" role="alert">
                {{this.err}}
              </div>

              <div class="row form-group">
                <div class="col-md-6 mb-4">
                      <span class="" v-html="$t('intern_bankdata.bank')"></span>
                      <input type="text" class="form-control" name="sepa[bank]" v-model.trim="bankname">
                </div>

                <div class="col-md-6">
                      <span class="" v-html="$t('intern_bankdata.owner')"></span>
                      <input type="text" class="form-control" name="sepa[owner]" v-model.trim="owner" @blur="$v.owner.$touch()" :class="{ 'is-invalid': $v.owner.$error }" >
                      <div class="invalid-feedback" v-if="!$v.owner.required">Bitte Konto-inhaber eingeben</div>
                </div>
              </div>
              <div class="row form-group">
                <div class="col-md-6 mb-4">
                    <span class="" v-html="$t('intern_bankdata.bic')"></span>
                    <input type="text" class="form-control" name="sepa[bic]" v-model.trim="bic" @blur="$v.bic.$touch()" :class="{ 'is-invalid': $v.bic.$error }" >
                    <div class="invalid-feedback" v-if="!$v.bic.required">Bitte BIC eingeben</div>
                </div>

                <div class="col-md-6">
                    <span class="" v-html="$t('intern_bankdata.iban')"></span>
                    <input type="text" class="form-control" name="sepa[iban_new]" v-model.trim="iban" @blur="$v.iban.$touch()" :class="{ 'is-invalid': $v.iban.$error }">
                    <div class="invalid-feedback" v-if="!$v.iban.required">Bitte IBAN eingeben</div>
                </div>
              </div>


              <div>
                <span v-html="$t('intern_bankdata.legal_info')"></span>
              </div>
            </div>

            <span v-if="!sepaInfo">{{$t('intern_rechnung_bezahlen.zahlung_hinweis')}}</span>

            <div class="mt-3">
                <button class="btn btn-success"             @click="back">Zurück</button>
                <button v-if="sepaInfo" class="btn btn-success float-right" @click="submitMandateAndPay">{{$t('intern_bankdata.button_speichern_und_bezahlen')}}</button>
                <button v-if="!sepaInfo" class="btn btn-success float-right" @click="pay">{{$t('intern_rechnung_bezahlen.button_Leistungen_bezahlen')}}</button>
            </div>
        </div>
    </div>
</template>

<script>
    import Booking  from '../../../classes/Booking';
    import { required } from 'vuelidate/lib/validators';

    export default {
        data() {
            return {
                selectedPacket: null,
                extensions: null,
                total_gross: 0,
                total_net: 0,
                mwst: 0,
                /*submitted: false,*/
                qpay: null,
                host: '',
                bankname: '',
                owner: '',
                bic:'',
                iban:'',
                sepaInfo: 1,
                invoice: [],
                err : null

            }
        },
        methods: {
            scrollTop() {
                window.scrollTo(0, 0);
            },
            submitMandateAndPay(){
              const bankdata = {
                    bankname : this.bankname,
                    owner : this.owner,
                    bic : this.bic,
                    iban : this.iban
              }
              this.$store.state.loading = true;
                this.$http.post('stripe/stripeApi/createMandateAndPayInvoice', bankdata).then(response => {
                  const data = JSON.parse(response.data);
                  this.invoice = data.invoice;
                  this.sepa = data.sepa;
                  this.$router.push({ name: 'invoice-payment-submit' , params:{ invoice_id : this.invoice.id}});
                }).catch(error => {
                  console.log('error: ' + error);
                  this.$bvModal.msgBoxOk(error.response.data.data, {
                        title: 'Fehler',
                        okVariant: 'secondary',
                        okTitle: 'Schließen'
                  }).then( value => {
                        this.$emit('nextTab', new Booking());
                  }).catch(error => {console.log(error);});
                }).then(() => {
                  this.$store.state.loading = false;
                });
            },
            pay() {
                this.$store.state.loading = true;
                this.$http.post('stripe/stripeApi/createMandateAndPayInvoice').then(response => {
                  const data = JSON.parse(response.data);
                  this.invoice = data.invoice;
                  this.sepa = data.sepa;
                  this.$router.push({ name: 'invoice-payment-submit' , params:{ invoice_id : this.invoice.id}});
                }).catch(error => {
                  console.log('error: ' + error);
                  this.$bvModal.msgBoxOk(error.response.data.data, {
                        title: 'Fehler',
                        okVariant: 'secondary',
                        okTitle: 'Schließen'
                  });
                }).then(() => {
                  this.$store.state.loading = false;
                });
            },
            back() {
                this.$emit('moveTo', 'address');
            },
            noBooking() {
                this.$bvModal.msgBoxOk('Transaction kann nicht durchgeführt werden. Sie haben kein Paket gewählt', {
                    title: 'Fehler',
                    okVariant: 'secondary',
                    okTitle: 'Schließen'
                }).then( value => {
                    this.$emit('nextTab', new Booking());
                }).catch(error => {console.log(error);});
            }
        },
        beforeCreate() {
            this.$store.state.loading = true;
            this.$http.get('UserApi/GetSepaInfoStatus').then(response => {
               this.sepaInfo = JSON.parse(response.data);
            }).catch( error => {
                console.log(error);
            }).then(() => {
                this.$store.state.loading = false;
            });
        },
        created () {
            this.scrollTop;
            if(this.$cookies.isKey('currentBooking')){
                let booking         = Booking.getObjectFromJSON(this.$cookies.get('currentBooking'));
                if(booking.getArticleCount() < 1){
                    this.noBooking();
                    return null;
                }
                this.extensions     = booking.getImprovementObjects();
                this.selectedPacket = booking.getPacket();
                this.total_gross    = parseFloat(this.selectedPacket.price ? this.selectedPacket.price * this.selectedPacket.duration : 0);
                if(this.extensions){
                    let sum_of_extensions = this.extensions.reduce( (el_1, el_2) => { return {price: parseFloat(el_1.price) + parseFloat(el_2.price)}}, {price: 0});
                    this.total_gross      += sum_of_extensions.price;
                }

                this.total_net      = this.total_gross / 1.19;
                this.mwst           = this.total_gross - this.total_net;

            }else{
                this.noBooking();
            }
        },
        validations: {
            owner: {required},
            bic: {required},
            iban: {required}
        },
    }
</script>

<style scoped>
.checkout{
    width: 80%;
    margin: 0 auto;
}
.checkout th, .checkout td{
    padding: 8px;
}
tfoot{
    border-top: 1px solid gray;
}
.brutto{
    color: #5FA963;
    font-weight: bolder;
    font-size: 16px;
}
.paymentWindow{
    width: 100%;
    height: 700px;
    border: none;
}
.hide{
    display: none;
}
@media only screen and (max-width: 768px) {
    .checkout{
        width: 100%;
    }
    .checkout th, .checkout td{
        padding: 8px 0;
    }
}
</style>
